"use strict";
var $ = require("../internals/export");
var isArray = require("../internals/is-array");
$({ target: "Array", stat: true }, {
  isArray
});
